import script from "./PayStubDetailsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PayStubDetailsPage.vue?vue&type=script&setup=true&lang=js"

import "./PayStubDetailsPage.vue?vue&type=style&index=0&id=0e173b95&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e173b95"]])

export default __exports__